<template>
    <svg class="k2eJge" style="width:16px;height:16px;" viewBox="0 0 16 12" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12.8 0l1.6 3.2H12L10.4 0H8.8l1.6 3.2H8L6.4 0H4.8l1.6 3.2H4L2.4 0h-.8C.72 0 .008.72.008 1.6L0 11.2c0 .88.72 1.6 1.6 1.6h12.8c.88 0 1.6-.72 1.6-1.6V0h-3.2z">
        </path>
    </svg>
</template>
<script>
export default {
    name: 'Mp4Svg',
}
</script>